import styled from "styled-components";

export const SearchResult = styled.p`
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  text-align: start;
  margin-top: auto;
  margin-bottom: 2.5px;
`;
